import { createContext } from 'react';
import type { UserType } from '@/types/users';

export interface AuthContextType {
  user: UserType | null;
  token: string | null;
  externalToken: string | null;
  isLoggedIn: boolean;
  isLoading: boolean;
  login: (
    userData: UserType,
    tokenReceived: string,
    externalTokenReceived?: string
  ) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType | null>(null);
